// Legacy Worker Productivity form was removed from /report/form (now a pure hub).
// Guard on the old form's presence so this dead code never runs / errors there.
if (window.location.pathname.startsWith("/report/form") && document.querySelector('.work-report')) {
    let searchTimeout = null;
    const userSearchInput = $('#m-userSearch');
    const userDropdown = $('#m-userDropdown');
    const userSearchLoading = $('#m-userSearchLoading');
    const userHoverTooltip = $('#m-userHoverTooltip');
    UserTooltip(userHoverTooltip, userSearchInput);
    userSearchInput.on('input', function () {
        const query = $(this).val().trim();

        // Clear selection when input changes
        if (query === '') {
            userSearchInput.removeAttr('data-id');
            userSearchInput.removeData('user');
            userHoverTooltip.addClass('hidden');

        } else {
            const currentDisplayValue = `${$(this).data('user')?.first_name || ''} ${$(this).data('user')?.last_name || ''}`.trim();
            if (query !== currentDisplayValue) {
                userSearchInput.removeAttr('data-id');
                userSearchInput.removeData('user');
                userHoverTooltip.addClass('hidden');
            }
        }

        if (query.length < 2) {
            userDropdown.addClass('hidden');
            return;
        }

        clearTimeout(searchTimeout);
        userSearchLoading.removeClass('hidden');

        searchTimeout = setTimeout(function () {
            searchUser(query).done(function (response) {
                userSearchLoading.addClass('hidden');
                userDropdown.empty();

                if (!response.users || response.users.length === 0) {
                    userDropdown.append('<div class="px-4 py-3 text-sm text-slate-500">No users found</div>');
                } else {
                    $.each(response.users, function (index, user) {
                        const userItem = assignUserItem(user, userSearchInput, userDropdown);
                        userDropdown.append(userItem);
                    });
                }
                userDropdown.removeClass('hidden');
            }).fail(function () {
                userSearchLoading.addClass('hidden');
            });
        }, 500);
    });
    $('.report-generate').on('click', function () {
        const btn = $(this);
        const user_id = userSearchInput.attr('data-id');
        const fromDate = $('#fromDate').val();
        const toDate = $('#toDate').val();
        const csrftoken = $("[name=csrfmiddlewaretoken]").val();
        if (!user_id) {
            Toast.show('Please select a user for the report.', 'error', 3000);
            return false;
        }
        const loadingBtn = new LoadingButton(btn);
        loadingBtn.start();
        const fromDateUTC = fromDate ? new Date(fromDate).toISOString() : null;
        const toDateUTC = toDate ? new Date(toDate).toISOString() : null;
        if (fromDateUTC && toDateUTC && fromDateUTC > toDateUTC) {
            Toast.show('From Date cannot be later than To Date', 'error', 3000);
            loadingBtn.stop();
            return false;
        }
        const reportSection = $('.report-section');
        $.ajax({
            url: '/api/task/user',
            method: 'GET',
            headers: {
                'X-CSRFToken': csrftoken
            },
            data: {
                user_id: user_id,
                from_date: fromDateUTC,
                to_date: toDateUTC
            }
            }).done(function(response) {
                loadingBtn.stop();
                reportSection.removeClass('hidden');
                const parsedTasks = response.tasks.map(task => ({
                ...task,
                entry_data: task.entry_data ? JSON.parse(task.entry_data) : null
                }));
                updateTaskData(parsedTasks);
                $('.task-table-body').html(response.html);
                window.reportGpsMessages = response.messages || [];
                initializeMap(response.messages);
            }).fail(function(jqXHR) {
            try {
                const res = JSON.parse(jqXHR.responseText);
                Toast.show(res.error, "error", 3000);
            } catch (e) {
                Toast.show(e, "error", 3000);
            }
            loadingBtn.stop();
        });
    });
    
    $('.productivity-card').on('click', function () {
        $('.work-report').removeClass('hidden');
    });

    function parseGpsPoints(messages) {
        const points = [];
        (messages || []).forEach(function (m) {
            try {
                const payload = JSON.parse(m.string_value);
                if (!payload.latitude || !payload.longitude) return;
                points.push({
                    lat: parseFloat(payload.latitude),
                    lng: parseFloat(payload.longitude),
                    timestamp: new Date(m.time / 1000000)
                });
            } catch (e) {}
        });
        points.sort(function (a, b) { return a.timestamp - b.timestamp; });
        return points;
    }

    function blockForPoint(point, blockFeatures) {
        const pt = turf.point([point.lng, point.lat]);
        for (let i = 0; i < blockFeatures.length; i++) {
            const f = blockFeatures[i];
            try {
                if (turf.booleanPointInPolygon(pt, f.poly)) return f;
            } catch (e) {}
        }
        return null;
    }

    function buildTimeline(points, blockFeatures) {
        const segments = [];
        let current = null;
        points.forEach(function (p) {
            const b = blockForPoint(p, blockFeatures);
            const name = b ? b.name : null;
            if (current && current.name === name) {
                current.end = p.timestamp;
            } else {
                if (current) segments.push(current);
                current = { name: name, start: p.timestamp, end: p.timestamp };
            }
        });
        if (current) segments.push(current);
        return segments;
    }

    function formatDuration(ms) {
        if (ms < 60000) return Math.round(ms / 1000) + 's';
        const totalMin = Math.round(ms / 60000);
        const h = Math.floor(totalMin / 60);
        const m = totalMin % 60;
        if (h && m) return h + 'h ' + m + 'm';
        if (h) return h + 'h';
        return m + 'm';
    }

    function formatTime(d) {
        return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    }

    function formatDateShort(d) {
        return d.toLocaleDateString([], { month: 'short', day: 'numeric' });
    }

    $(document).on('click', '#timelineBtn', function () {
        const messages = window.reportGpsMessages || [];
        const points = parseGpsPoints(messages);
        if (points.length === 0) {
            Toast.show('No GPS data available for timeline.', 'error', 3000);
            return;
        }
        if (typeof blocks === 'undefined' || !blocks || !blocks.features || blocks.features.length === 0) {
            Toast.show('No blocks configured.', 'error', 3000);
            return;
        }
        const blockFeatures = blocks.features
            .filter(function (f) { return f.geometry; })
            .map(function (f) {
                return {
                    name: f.name || (f.properties && f.properties.name) || 'Unnamed',
                    poly: { type: 'Feature', geometry: f.geometry, properties: {} }
                };
            });
        const segments = buildTimeline(points, blockFeatures);
        if (segments.length === 0) {
            Toast.show('No timeline segments to display.', 'info', 3000);
            return;
        }

        let insideMs = 0;
        let outsideMs = 0;
        let undefinedCount = 0;
        const uniqueBlocks = new Set();
        const rows = segments.map(function (s, i) {
            const dur = s.end - s.start;
            const isInside = !!s.name;
            if (isInside) { insideMs += dur; uniqueBlocks.add(s.name); } else { outsideMs += dur; undefinedCount++; }
            const sameDay = s.start.toDateString() === s.end.toDateString();
            const startLabel = sameDay
                ? formatTime(s.start)
                : formatDateShort(s.start) + ' ' + formatTime(s.start);
            const endLabel = sameDay
                ? formatTime(s.end)
                : formatDateShort(s.end) + ' ' + formatTime(s.end);
            const badge = isInside
                ? '<span class="inline-flex items-center gap-1 bg-emerald-100 text-emerald-700 text-xs px-2 py-1 rounded-full"><i class="bi bi-geo-alt"></i>' + s.name + '</span>'
                : '<span class="inline-flex items-center gap-1 bg-slate-100 text-slate-500 text-xs px-2 py-1 rounded-full"><i class="bi bi-geo"></i>Undefined block</span>';
            const rowClass = isInside ? 'custom-row' : 'custom-row bg-slate-50/50';
            return '<tr class="' + rowClass + '">' +
                '<td class="px-4 py-3 text-sm text-slate-600">' + (i + 1) + '</td>' +
                '<td class="px-4 py-3">' + badge + '</td>' +
                '<td class="px-4 py-3 text-sm text-slate-700">' + formatDateShort(s.start) + '</td>' +
                '<td class="px-4 py-3 text-sm text-slate-700">' + startLabel + ' &rarr; ' + endLabel + '</td>' +
                '<td class="px-4 py-3 text-sm font-medium ' + (isInside ? 'text-slate-900' : 'text-slate-500') + '">' + formatDuration(dur) + '</td>' +
                '</tr>';
        }).join('');

        const html =
            '<div class="mb-3 flex flex-wrap items-center gap-4 text-sm text-slate-600">' +
                '<span>Inside blocks: <span class="font-semibold text-emerald-700">' + formatDuration(insideMs) + '</span></span>' +
                '<span>Undefined block: <span class="font-semibold text-slate-700">' + formatDuration(outsideMs) + '</span></span>' +
                '<span>Block visits: <span class="font-semibold text-slate-900">' + uniqueBlocks.size + '</span></span>' +
                '<span>Undefined visits: <span class="font-semibold text-slate-900">' + undefinedCount + '</span></span>' +
            '</div>' +
            '<div class="responsive-task-table"><table class="w-full border-separate custom-table">' +
            '<thead class="bg-slate-100 border-b border-slate-200"><tr>' +
            '<th class="px-4 py-3 text-left text-xs font-semibold text-slate-700 uppercase tracking-wider">#</th>' +
            '<th class="px-4 py-3 text-left text-xs font-semibold text-slate-700 uppercase tracking-wider">Block</th>' +
            '<th class="px-4 py-3 text-left text-xs font-semibold text-slate-700 uppercase tracking-wider">Date</th>' +
            '<th class="px-4 py-3 text-left text-xs font-semibold text-slate-700 uppercase tracking-wider">Time</th>' +
            '<th class="px-4 py-3 text-left text-xs font-semibold text-slate-700 uppercase tracking-wider">Duration</th>' +
            '</tr></thead><tbody class="divide-y divide-slate-200">' + rows + '</tbody></table></div>';

        const dialog = new Dialog('Block Visit Timeline', html, { size: '3xl' });
        dialog.setButtons([{ name: 'Close', dismiss: true }]);
        dialog.show();
    });
};